import { useState, useEffect } from "react";
import useDebounce from "./useDebounce";
import { CampaignSuggestService } from "../utils/api";

const useCampaignsSelect = value => {
  const [loading, setLoading] = useState(false);
  const [term, setTerm] = useState("");
  const [opts, setOptions] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const debTerm = useDebounce(term, 300);

  const onSearchChange = e => {
    setTerm(e.target.value);
  };

  useEffect(() => {
    setLoading(true);
    CampaignSuggestService({ term: debTerm })
      .then(data => {
        setLoading(false);
        setOptions(data.campaigns);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [debTerm]);

  useEffect(() => {
    const exists = opts.find(opt => {
      return opt.value == value;
    });

    if (!value || exists) {
      return;
    }

    setLoading(true);

    CampaignSuggestService({ id: value })
      .then(data => {
        setOptions(data.campaigns);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [value]);

  useEffect(() => {
    if (disabled) {
      setOptions([]);
    }
  }, [disabled]);

  const handleClose = () => {
    setOptions([]);
    setTerm("");
  };

  return {
    options: opts,
    disabled,
    loading,
    handleSearchChange: onSearchChange,
    setOptions,
    setDisabled,
    searchable: true,
    ajax: true,
    onClose: handleClose
  };
};

export default useCampaignsSelect;
